import { useContext } from 'react';
import { AppContext } from '../../context/appContext';

/**
 * returns the flags data
 * @param {string} key the key of the feature flag whose value is being retrieved.
 * @returns {object} containing keys which are the features and values that are of boolean type
 * indicating whether this feature is turned on or off.
 */
const useFeatureFlags = key => {
  const [data] = useContext(AppContext);
  return data?.flags?.[key];
};

export const useGlobalConfig = () => useContext(AppContext)[0]?.flags?.config || {};

export default useFeatureFlags;
